import { OrganizationsScreenTypes } from "../../../services/organizations";
import { useOrganizationsScreenContext } from "../../../context/organizations/OrganizationsScreenContextProvider";

function OrganizationsHeader() {
  const {
    selectedTab,
    setSelectedTab,
    isAllOrganizationsSelected,
    setIsAllOrganizationsSelected,
    selectedSideFilterOrganization,
    setSelectedSideFilterOrganization,
    selectedOrganizationTableRowIds,
    organizationRows,
    setIsDefaultParentExpanded
  } = useOrganizationsScreenContext();

  const isMultipleRowsSelected = selectedOrganizationTableRowIds.length > 1;
  const selectedTableRow =
    selectedOrganizationTableRowIds.length === 1
      ? (organizationRows.find(
          (row) => row.id === selectedOrganizationTableRowIds[0],
        ) ?? null)
      : null;

  const showOrganizationsList =
    isAllOrganizationsSelected ||
    (selectedSideFilterOrganization?.isClient &&
      selectedSideFilterOrganization.branches.length > 0) ||
    (selectedSideFilterOrganization?.isBranch &&
      selectedSideFilterOrganization.subBranches.length > 0);

  const baseScreens: {
    screen: OrganizationsScreenTypes;
    label: string;
  }[] = [
    { screen: "organizationsList", label: "רשימת האירגונים" },
    { screen: "organizationProfile", label: "פרופיל אירגון" },
    // { screen: "activityLog", label: "יומן פעילות" },
    // { screen: "messagesLog", label: "יומן הודעות" },
  ];

  const SCREENS = baseScreens.filter(
    (screen) => showOrganizationsList || screen.screen !== "organizationsList",
  );

  const handleChangeScreen = (screen: OrganizationsScreenTypes) => {
    if (screen === "organizationProfile" && selectedTableRow) {
      setIsAllOrganizationsSelected(false);
      setIsDefaultParentExpanded(true);
      setSelectedSideFilterOrganization(selectedTableRow);
    }
    setSelectedTab(screen);
  };

  return (
    <div className="w-full bg-white px-4 shadow-md z-[2]">
      <div className="w-full h-full flex items-center">
        <div className="flex items-center gap-2 min-w-[400px]">
          <span className="text-2xl font-semibold leading-6 text-black">
            ניהול האירגון
          </span>
          <span className="text-2xl leading-6 text-deepAqua">&gt;</span>
          <span className="text-2xl font-semibold leading-6 text-deepAqua">
            {isAllOrganizationsSelected
              ? "כל הלקוחות"
              : (selectedSideFilterOrganization?.name ?? "")}
          </span>
        </div>

        <div className="flex-1 flex justify-center items-center gap-2">
          {SCREENS.map((scr, index) => {
            const isCurrent = scr.screen === selectedTab;
            const isProfileDisabled =
              isMultipleRowsSelected ||
              (isAllOrganizationsSelected && !selectedTableRow);
            const isDisabled =
              (scr.screen === "organizationProfile" && isProfileDisabled) ||
              scr.screen === "messagesLog" ||
              scr.screen === "activityLog";

            return (
              <button
                key={index}
                disabled={isDisabled}
                className={`p-4 text-sm
              ${
                isCurrent
                  ? "border-b-[3px] border-b-deepAqua font-semibold text-black"
                  : isDisabled
                    ? "text-darkerGray opacity-50"
                    : "text-darkerGray"
              }
              `}
                onClick={() => handleChangeScreen(scr.screen)}
              >
                {scr.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default OrganizationsHeader;
